import React from "react";
import "./App.scss";

import HomePage from "./pages/home/homepage.component";

function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
